import { StyleSheet, Text, View, Image, Dimensions } from "react-native";
import React from "react";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import useFetchImage from "../../../../hooks/useFetchImage";
import OverlayGIF from "./OverlayGIF";
const studentFront = require("../../../../../assets/images/cards/student-front.png");
const defaultProfilePic = require("../../../../../assets/images/home/default-avatar-profile-image.jpg");

const StudentCard = () => {
  const user = useAppSelector((s) => s.auth.subUser!);

  const isDefault =
    user.card?.images && user.card.images.front !== "Base-front-image"
      ? false
      : true;
  let userCardImageSource: any = !isDefault
    ? { uri: user.card!.images.front }
    : defaultProfilePic;
  const dateNow = new Date();
  const status =
    user &&
    user.card?.isic_data?.status &&
    user.card?.isic_data?.status !== "Pending"
      ? new Date(user.card?.expiry) > dateNow
        ? "VALID"
        : "EXPIRED"
      : "PENDING";
  const imageSrc = useFetchImage(
    "/users/profile/image/",
    user.card.images.front
  );
  if (imageSrc) {
    userCardImageSource = { uri: imageSrc };
  }
  return (
    <View style={styles.cardContainer}>
      <Image
        source={studentFront}
        style={[styles.card, status !== "VALID" && { tintColor: "gray" }]}
      />
      {status !== "VALID" && (
        <Image
          source={studentFront}
          style={[styles.card, { opacity: 0.3, position: "absolute" }]}
        />
      )}

      <View style={styles.cardContent}>
        <Text style={styles.cardNumber}>
          {user.card?.isic_data?.isic_card_number}
        </Text>
        <Text style={styles.institution}>{user.card?.institution}</Text>
        <Text style={styles.name}>{user.card?.name}</Text>
        <Text style={styles.dob}>{user.card?.dob}</Text>
        <Text style={styles.expiry}>{user.card?.expiry}</Text>
        <Image
          source={userCardImageSource}
          style={[
            styles.cardImage,
            status !== "VALID" && { tintColor: "gray" },
          ]}
          resizeMode="stretch"
        />
        {status !== "VALID" && (
          <Image
            source={userCardImageSource}
            style={[styles.cardImage, { opacity: 0.3, position: "absolute" }]}
          />
        )}
      </View>
      {user?.card &&
        user.card?.isic_data?.status !== "Pending" &&
        new Date(user.card?.expiry) > dateNow && <OverlayGIF />}
    </View>
  );
};

export default StudentCard;

const windowWidth = Dimensions.get("window").width;
const ratio = 1460 / 920;
const cardWidth = windowWidth * 0.95;
const cardHeight = cardWidth * ratio;
const styles = StyleSheet.create({
  cardContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    marginTop: 50,
  },
  card: {
    borderRadius: 20,
    height: cardHeight,
    width: cardWidth,
  },
  cardContent: {
    position: "absolute",
    width: cardHeight,
    height: cardWidth,
    transform: [{ rotate: "270deg" }],
  },
  institution: {
    position: "absolute",
    fontSize: 16,
    top: cardWidth * 0.514,
    left: cardHeight * 0.057,
  },

  name: {
    position: "absolute",
    fontSize: 16,
    top: cardWidth * 0.63,
    left: cardHeight * 0.057,
  },
  dob: {
    position: "absolute",
    fontSize: 16,
    top: cardWidth * 0.75,
    left: cardHeight * 0.057,
  },
  expiry: {
    position: "absolute",
    fontSize: 16,
    top: cardWidth * 0.87,
    left: cardHeight * 0.057,
  },
  cardImage: {
    position: "absolute",
    width: cardWidth * 0.468,
    height: cardHeight * 0.354,
    left: cardHeight * 0.65,
    top: cardWidth * 0.184,
  },
  cardNumber: {
    position: "absolute",
    top: cardWidth * 0.08,
    left: cardHeight * 0.621,
    zIndex: 10,
  },
});
